// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1wYDJ","sendOtp":"AuthorizeToLogin_sendOtp__1f6zi"};